import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBlurImageConfig } from '@/data/landingConfig/landingBlurImageConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BlurImage } from './schemaObject';

interface Props {}
const BlurImage: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_BlurImage} />
			<LandingTemplate
				data={landingBlurImageConfig}
				funnelLinkService={GenerateLandingLinkService.funnelBlur()}
			/>
		</>
	);
};

export default BlurImage;
